<template>
  <div>
    <BuscaAvancada v-model="relatorio_oportunidades.filtros" />
  </div>
</template>

<script>
import BuscaAvancada from "@/modules/oportunidades/Components/BuscaAvancada.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: { BuscaAvancada },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {},
  computed: {
    ...mapState("relatorios", ["relatorio_oportunidades"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.relatorio[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.relatorio.$touch();
      return !this.$v.relatorio.$anyError;
    },
  },
  created() {},
};
</script>
